// IntroHome.js
import {useNavigate} from 'react-router-dom';

export default function IntroHome(props) {
    const comandoNavigazione = useNavigate();
    
    function vaiLink(link) {
        comandoNavigazione(link);
        window.scrollTo(0, 0);
    }

    return (
        <section className="intro-section">
            <div className="intro-container">
                <h2>Cos’è Gestione Sportiva?</h2>
                
                <p>
                    <strong>Il gestionale semplice e completo,</strong>
                    <br/>
                    che vale di più e ti costa meno
                </p>
                <div className="punti-chiave">
                    <div>Per associazioni, società sportive e palestre</div>
                    <div>Accesso da PC e smartphone</div>
                    <div>Personalizzabile sulle tue esigenze</div>
                </div>

                <div className="bottoni-home">
                <a className="btn" onClick={() => vaiLink("/provaGratis")}>Prova gratis →</a>
                <a className="btn secondary" onClick={() => vaiLink("/scaricaApp")}>APP Iscritti →</a>
                <a className="btn secondary" onClick={() => vaiLink("/acquista")}>Acquista →</a>
                <a className="btn secondary" onClick={() => window.location.href = props.urlServizio}>Accedi →</a>
                </div>
            </div>
        </section>
    );
}
